export const SEPACountries = [
  'FR',
  'GB',
  'BE',
  'DE',
  'GR',
  'LU',
  'ES',
  'IT',
  'NL',
  'FI',
  'NO',
  'DK',
  'PL',
  'CH',
  'SE', // Sweden
  'IE', // Ireland
  'PT', // Portugal
  'MT', // Malta
  'AT', // Austria (Autriche)
  'LV', // Latvia (Lettonie)
  'LT', // Lithuania (Lutuanie)
  'SI', // Slovenia (Slovenie)
  'SK', // Slovakia (Slovaquie)
  'EE', // Estonia (Estonie)
  'BG', // Bulgaria (Bulgarie)
  'CY', // Cyprus (Chypre)
  'CZ', // Czech Republic
  'HU', // Hungary
  'HR', // Croatia
  'RO', // Romania
  'IS', // Iceland
  'MC', // Monaco
  'LI', // Liechtenstein
  'SM', // San Marino
  'GI', // Gibraltar
  'AD', // Andorra
];

export function isSepaCountry(country: string): boolean {
  return SEPACountries.includes(country);
}

/**
 * Checks if the transfer is a cross-currency or international transfer.
 */
export function isInternationalTransfer({
  sourceCurrency,
  targetCurrency,
  targetCountry,
}: {
  sourceCurrency: string;
  targetCurrency: string;
  targetCountry?: string;
}): boolean {
  // Always return true if cross-currency
  if (sourceCurrency !== targetCurrency) {
    return true;
  }

  // For GBP to GBP, return true if country is not GB.
  if (
    sourceCurrency === 'GBP' &&
    targetCurrency === 'GBP' &&
    targetCountry &&
    targetCountry !== 'GB'
  ) {
    return true;
  }

  // Default to true if the target country is undefined.
  // The check on '/' is to handle weird cases where the country is not set but also not null.
  const isKnownSepaCountry =
    targetCountry && isCountryValid(targetCountry)
      ? isSepaCountry(targetCountry)
      : true;

  // If EUR to EUR, return true if the country is non SEPA
  return (
    sourceCurrency === 'EUR' && targetCurrency === 'EUR' && !isKnownSepaCountry
  );
}

function isCountryValid(country: string | undefined): boolean {
  return country !== undefined && /^[A-Z]{2}$/.test(country);
}
